import styled from 'styled-components';
import { Tag } from 'src/components/atoms';

export const LanguageChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-content: flex-start;
`;

export const OverflowChipWrapper = styled.div`
  pointer-events: auto !important;
  cursor: default !important;

  &,
  &:hover,
  &:active,
  & *,
  & *:hover,
  & *:active {
    cursor: default !important;
    pointer-events: auto !important;
  }
`;

export const LanguageChip = styled(Tag)`
  box-sizing: border-box;
  height: 24px;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 9999px !important;
  border: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N500
        : props.theme.atlas.core.color.gray[500]} !important;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default} !important;
  background-color: transparent !important;

  &:hover {
    background-color: transparent !important;
  }
`;

export const OverflowChip = styled(LanguageChip)`
  /* Styling inherited from LanguageChip */
`;
